import useCustomStoreHooks from '@/hooks/useStore';
import './index.less';

export default function Index() {
  const { translate } = useCustomStoreHooks();
  const $t = (key) => translate({ translate_language_key: 'component.footer.language', key });

  return <div className="page-footer">
    <div className='page-footer-content'>
      <div className='left'>
        <div className='logos'>
          <div className='logo'></div>
          <div className='logo-purchase'></div>
        </div>
        <div className='copy-right'>{$t('Copyright ©2023 Shanghai Zhengyuan Computer Technology Co., Ltd.  Hu ICP No.17047232-7')}</div>
      </div>
      <div className='right'>
        <div className='contact-us-title'>{$t('Contact Us')}</div>
        <div className='mail right-item'>
          <div className='right-span'>{$t('Email')}：zhangshuqiang@cpgroup.cn</div>
        </div>
        {/* <div className='mobile right-item'>
          <div className='right-span'>{$t('Contact Us')}：+8615522853360</div>
        </div> */}
      </div>
    </div>
  </div>;
};
